import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

// EOS-5653: Oversized Vehicle flag with an info icon showing the definition on hover
function OversizedVehicleCheckbox({ id, checked, disabled, onChange, message }) {
    return (
        <>
            <label className='form-label'>Oversized Vehicle
                <OverlayTrigger placement='top' overlay={<Tooltip id={`${id}-info`} className='oversized-vehicle-tooltip'><div dangerouslySetInnerHTML={{ __html: message }} /></Tooltip>}>
                    <i className='fa fa-info-circle text-primary ms-1' role='button' tabIndex={0} aria-label='Oversized vehicle definition' />
                </OverlayTrigger>
            </label>
            <div className='form-check align-items-center'>
                <input
                    type='checkbox'
                    className='form-check-input'
                    id={id}
                    name='is_oversized'
                    checked={checked === true || checked == '1'}
                    disabled={disabled}
                    onChange={onChange} />
                <label className='form-check-label' htmlFor={id} />
            </div>
        </>
    )
}

OversizedVehicleCheckbox.propTypes = {
    id: PropTypes.string,
    checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    message: PropTypes.string
}

export default OversizedVehicleCheckbox
